import { Trans } from 'lingui-react';
import PropTypes from 'prop-types';
import React from 'react';

import WarningIcon from './WarningIcon';
import WarningText from './WarningText';

function WarningLabel({ label }) {
  return (
    <div>
      <WarningIcon />
      <WarningText>
        <Trans id={label} />
      </WarningText>
    </div>
  );
}

WarningLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

export default WarningLabel;



// WEBPACK FOOTER //
// ./components/WarningLabel/index.js